import { React, useState } from "react";
// import CssBaseline from '@mui/material/CssBaseline';
// import { createTheme, ThemeProvider } from '@mui/material/styles';
// import { isMobile } from 'react-device-detect';
import { IconButton, InputAdornment, Switch, Typography, Button, MenuItem, TextField } from '@mui/material';
import RudderLogo from "../../img/rudder_lite_logo.svg";
import { useTheme } from '@mui/material/styles';
import LeftBG from '../../img/left_bg.jpg';
import { useNavigate, Link } from "react-router-dom";

// const defaultTheme = createTheme();

function SignUpPage(props) {

    const theme = useTheme();
    let navigate = useNavigate();
    const [age, setAge] = useState('');

    const handleChange = (event) => {
        setAge(event.target.value);
    };
    const handleSubmit = async (e) => {
        navigate("/dashboard");
    };
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const handleClickShowPassword = (passwordType) => {
        if (passwordType === 'password') {
            setShowPassword(!showPassword);
        } else if (passwordType === 'confirmPassword') {
            setShowConfirmPassword(!showConfirmPassword);
        }
    }
    return (
        <main>
            <div className='row m-0 p-0' style={{ height: "100vh" }}>
                <div className='col-md-3 col-sm-12 d-none d-md-block'
                    style={{
                        backgroundImage: `url(${LeftBG})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundColor: (t) =>
                            t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        borderRadius: 0,
                        overflow: "hidden"
                    }}
                >
                </div>

                <div className='col-md-9 col-sm-12 position-relative p-0'>
                    <Link to="/" style={{ textDecoration: 'inherit' }}>
                        <div className='position-absolute p-5'>
                            <Button
                                disableElevation
                                variant="text"
                                size='small'
                                startIcon={<i className="ri-arrow-left-s-line"></i>}
                                sx={{ borderRadius: 50, px: 2 }}
                            >
                                Return to login
                            </Button>
                        </div>
                    </Link>

                    <div className='container h-100'>
                        <div className='row h-100'>
                            <div className='col-md-5 col-sm-12 mx-auto h-100 align-items-start justify-content-center d-flex flex-column'>

                                <img className='mb-0' alt="" height={70} src={RudderLogo} />
                                <Typography className='mb-1' variant="h5" fontWeight={600}>
                                    Sign up & Grow your Network.
                                </Typography>

                                <Typography className='mb-3' variant="body2" color={theme.palette.grey[700]}>
                                    All we need is a few details. Then you'll be set up and able to simplify network management.
                                </Typography>
                                <form onSubmit={handleSubmit}>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <TextField
                                                label="First Name"
                                                fullWidth
                                                // error
                                                margin="dense"
                                                required
                                                helperText=""
                                                variant="filled"
                                            />
                                        </div>
                                        <div className='col-md-6'>
                                            <TextField
                                                label="Last Name"
                                                fullWidth
                                                // error
                                                margin="dense"
                                                required
                                                helperText=""
                                                variant="filled"
                                            />
                                        </div>
                                        <div className='col-md-6'>
                                            <TextField
                                                label="Email Address"
                                                fullWidth
                                                // error
                                                margin="dense"
                                                required
                                                helperText=""
                                                id="reddit-input"
                                                variant="filled"
                                            />
                                        </div>
                                        <div className='col-md-6'>
                                            <TextField
                                                label="Enter Phone Number"
                                                fullWidth
                                                // error
                                                margin="dense"
                                                required
                                                helperText=""
                                                InputProps={{
                                                    startAdornment: (<InputAdornment position="start"><Switch /></InputAdornment>),
                                                }}
                                                id="reddit-input1"
                                                variant="filled"
                                            />
                                        </div>
                                        <div className='col-md-6'>
                                            <TextField
                                                id="demo-simple-select-filled"
                                                select
                                                fullWidth
                                                value={age}
                                                label="Country"
                                                variant='filled'
                                                margin="dense"
                                                onChange={handleChange}
                                                helperText=""
                                            >
                                                <MenuItem value="">
                                                    <em>None</em>
                                                </MenuItem>
                                                <MenuItem value={10}>Ten</MenuItem>
                                                <MenuItem value={20}>Twenty</MenuItem>
                                                <MenuItem value={30}>Thirty</MenuItem>
                                            </TextField>
                                        </div>
                                        <div className='col-md-6'>
                                            <TextField
                                                id="demo-simple-select-filled"
                                                select
                                                fullWidth
                                                value={age}
                                                label="Timezone"
                                                variant='filled'
                                                margin="dense"
                                                onChange={handleChange}
                                                helperText=""
                                            >
                                                <MenuItem value="">
                                                    <em>None</em>
                                                </MenuItem>
                                                <MenuItem value={10}>Ten</MenuItem>
                                                <MenuItem value={20}>Twenty</MenuItem>
                                                <MenuItem value={30}>Thirty</MenuItem>
                                            </TextField>
                                        </div>
                                        <div className='col-md-12'>
                                            <TextField
                                                label="Password"
                                                fullWidth
                                                // error
                                                margin="dense"
                                                required
                                                type={showPassword ? "text" : "password"}
                                                helperText=""
                                                InputProps={{
                                                    endAdornment: (<InputAdornment position="end"><IconButton onClick={() => handleClickShowPassword("password")}><i className={showPassword ? "ri-eye-line" : 'ri-eye-off-line'}></i></IconButton></InputAdornment>),
                                                }}
                                                id="reddit-input"
                                                variant="filled"
                                            />
                                        </div>
                                        <div className='col-md-12'>
                                            <TextField
                                                label="Confirm Password"
                                                fullWidth
                                                // error
                                                margin="dense"
                                                required
                                                type={showConfirmPassword ? "text" : "password"}
                                                helperText=""
                                                InputProps={{
                                                    endAdornment: (<InputAdornment position="end"><IconButton onClick={() => handleClickShowPassword("confirmPassword")}><i className={showConfirmPassword ? "ri-eye-line" : 'ri-eye-off-line'}></i></IconButton></InputAdornment>),
                                                    className: "req",
                                                }}
                                                id="reddit-input"
                                                variant="filled"
                                            />
                                        </div>
                                        <div className='col-md-6'>
                                            <Typography className='mb-3 d-flex align-items-center' color={false ? theme.palette.grey[500] : "primary.main"} variant="body2">
                                                <i className="ri-checkbox-blank-circle-line me-2"></i>
                                                <i className="ri-checkbox-circle-fill me-2"></i>
                                                <span>Lowercase characters.</span>
                                            </Typography>
                                        </div>
                                        <div className='col-md-6'>
                                            <Typography className='mb-3 d-flex align-items-center' variant="body2" color={theme.palette.grey[500]}>
                                                <i className="ri-checkbox-blank-circle-line me-2"></i>
                                                <span>Uppercase characters.</span>
                                            </Typography>
                                        </div>
                                        <div className='col-md-6'>
                                            <Typography className='mb-3 d-flex align-items-center' variant="body2" color={theme.palette.grey[500]}>
                                                <i className="ri-checkbox-blank-circle-line me-2"></i>
                                                <span>Numbers.</span>
                                            </Typography>
                                        </div>
                                        <div className='col-md-6'>
                                            <Typography className='mb-3 d-flex align-items-center' variant="body2" color={theme.palette.grey[500]}>
                                                <i className="ri-checkbox-blank-circle-line me-2"></i>
                                                <span>8 characters minimum.</span>
                                            </Typography>
                                        </div>
                                    </div>
                                    <Button
                                        type="submit"
                                        fullWidth
                                        disableElevation
                                        variant="contained"
                                        size='large'
                                        startIcon={<i className="ri-login-circle-line"></i>}
                                        sx={{ my: 1 }}
                                    >
                                        Sign Up
                                    </Button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default SignUpPage;